module.exports = __webpack_public_path__ + "img/qrcode-broke.3245398d.jpg";